import {createSlice} from "@reduxjs/toolkit";

const initialScheduleSlice = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    scheduleForEdit: undefined
}

export const callTypes = {
    list: "list",
    action: "action"
}

export const schedulesSlice = createSlice({
    name: "schedules",
    initialState: initialScheduleSlice,
    reducers: {
        catchError: (state, action) =>{
            state.error = `${action.type}: ${action.payload.error}`;
            if(action.payload.callType === callTypes.list) {
                state.listLoading = false;
            }
            else{
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) =>{
            state.error = null;
            if(action.payload.callType === callTypes.list){
                state.listLoading = true;
            }
            else{
                state.actionsLoading = true;
            }
        },
        
        scheduleFetched: (state, action) =>{
            state.actionsLoading = false;
            state.scheduleForEdit = action.payload.scheduleForEdit;
            state.error = null;
        },
        
        schedulesFetched: (state, action) =>{
            const {totalCount, entities} = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        
        scheduleCreated: (state, action) =>{
            state.actionsLoading = false;
            state.error = null;
            state.entities.push(action.payload.schedule);
        },
        
    }
})